import { gql, useMutation } from '@apollo/client'
import { useEffect, useState } from 'react'
import { FormattedMessage, defineMessages, useIntl } from 'react-intl'
import { useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import Heading from 'components/v2/Heading'
import Card from '@10xLabs/react-web/components/Card'
import { Content } from 'components/v2/Content'
import { ForbiddenView } from 'features/App/components/ForbiddenView'
import { withLastUrl } from 'features/App/components/WithLastUrl'
import { FEATURES } from 'features/Roles/components/Permissions/constants'
import { NewLine } from 'features/Lines/components/NewLine'
import { messages as fileMessages } from 'messages/file'
import { usePushFileToS3 } from 'utils/file'
import { getQueries } from 'utils/route'
import { canWrite } from 'features/Users/utils'
import { useLogin } from 'features/Login/hooks'

const Header = styled.div<TSFixMe>`
  margin-bottom: 20px;
`

const messages = defineMessages({
  helmet: {
    id: 'lines.new.helmet',
    defaultMessage: 'New Line | Nexbus Admin'
  }
})

const CREATE_LINE = gql`
  mutation CreateLine($line: createCompanyLineInput!) {
    createCompanyLine(input: $line)
  }
`

const NewLineView = (): TSFixMe => {
  const location = useLocation()
  const navigate = useNavigate()
  const intl = useIntl()
  const login = useLogin()
  const [s3Error, setS3Error] = useState<string | undefined>()

  useEffect((): TSFixMe => {
    document.title = intl.formatMessage(messages.helmet)
  }, [])

  const [createLine, { data, loading, error }] = useMutation(CREATE_LINE)
  const pushFileToS3 = usePushFileToS3()

  const handleSubmit = async (line: TSFixMe): Promise<TSFixMe> => {
    let logoPath
    setS3Error(undefined)
    const { companyId } = getQueries(location.search)
    try {
      logoPath = await pushFileToS3(line.logo)
    } catch (ex) {
      setS3Error(intl.formatMessage(fileMessages.uploadFileError, { count: 1 }))
      return
    }

    createLine({
      variables: {
        line: {
          name: line.name,
          companyID: companyId,
          amenities: line.amenities,
          refundRules: line.refundRules,
          class: line.class,
          type: line.type,
          logoPath
        }
      },
      context: {
        hasUpload: true
      }
    })
  }

  useEffect((): TSFixMe => {
    if (data) {
      navigate('/lines')
    }
  }, [data])

  if (!canWrite(FEATURES.COMPANY_LINE, login.accessToken.policies)) {
    return <ForbiddenView feature={FEATURES.COMPANY_LINE} />
  }

  return (
    // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
    <Content hasSidebar hasHeader hasMaxWidth>
      <Header>
        <Heading.H3>
          <FormattedMessage id="lines.new.title" defaultMessage="Create line" />
        </Heading.H3>
      </Header>

      <section>
        <Card.Container>
          <NewLine onSubmit={handleSubmit} loading={loading} error={error} s3Error={s3Error} />
        </Card.Container>
      </section>
    </Content>
  )
}

export default withLastUrl(NewLineView)
